import Vue from 'vue'
import Router from 'vue-router'
import routes from './routes'
import store from '../store'

Vue.use(Router)

export const router = new Router({
  mode: 'history',
  routes: routes
})

router.beforeEach((to, from, next) => {
  const isAuthenticated = store.state.authentication.isAuthenticated
  const loginRequired = to.matched.some(record => record.meta.loginRequired)

  if (!loginRequired) return next()

  if (isAuthenticated) {
    return store.dispatch('authentication/restTokenValidate').then(validUser => {
      validUser ? next() : redirectToLogin()
    })
  }
  redirectToLogin()

  function redirectToLogin () {
    next({
      path: '/login',
      query: {
        redirect: to.fullPath
      }
    })
  }
})
